export default __webpack_public_path__ + "static/media/p1.bf7684f5.png";